const listaFamiliaresInitialState = {
  listaFamiliares: {
    loading: false,
    error: null,
    data: null,
  },
};

export default listaFamiliaresInitialState;
